export enum DispensarizationStatisticsParameters {
  From = 'From',
  To = 'To',
  ClinicIds = 'ClinicIds',
  BatchIds = 'BatchIds',
}

export enum DISPENSARIZATION_STATISTICS_KEYS_NAMES {
  tasksCount = 'tasksCount',
  callsAttemptCount = 'callsAttemptCount',
  tasksUnknownCount = 'tasksUnknownCount',
  callsNotAnswerAttemptCount = 'callsNotAnswerAttemptCount',
  tasksConfirmedCount = 'tasksConfirmedCount',
  tasksDeclinedCount = 'tasksDeclinedCount',
  tasksOperatorCount = 'tasksOperatorCount',
  firstCallsAttempt = 'firstCallsAttempt',
  secondCallsAttempt = 'secondCallsAttempt',
  thirdCallsAttempt = 'thirdCallsAttempt',
}

export const DISPENSARIZATION_STATISTICS_KEYS = [
  DISPENSARIZATION_STATISTICS_KEYS_NAMES.tasksCount,
  DISPENSARIZATION_STATISTICS_KEYS_NAMES.callsAttemptCount,
  DISPENSARIZATION_STATISTICS_KEYS_NAMES.tasksUnknownCount,
  DISPENSARIZATION_STATISTICS_KEYS_NAMES.callsNotAnswerAttemptCount,
  DISPENSARIZATION_STATISTICS_KEYS_NAMES.tasksConfirmedCount,
  DISPENSARIZATION_STATISTICS_KEYS_NAMES.tasksDeclinedCount,
  DISPENSARIZATION_STATISTICS_KEYS_NAMES.tasksOperatorCount,
  DISPENSARIZATION_STATISTICS_KEYS_NAMES.firstCallsAttempt,
  DISPENSARIZATION_STATISTICS_KEYS_NAMES.secondCallsAttempt,
  DISPENSARIZATION_STATISTICS_KEYS_NAMES.thirdCallsAttempt,
];

export const DISPENSARIZATION_STATISTICS_KEYS_MAP_TEXT = {
  [DISPENSARIZATION_STATISTICS_KEYS_NAMES.tasksCount]: 'Всего заданий',
  [DISPENSARIZATION_STATISTICS_KEYS_NAMES.callsAttemptCount]: 'Всего звонков',
  [DISPENSARIZATION_STATISTICS_KEYS_NAMES.tasksUnknownCount]:
    'В очереди на обработку',
  [DISPENSARIZATION_STATISTICS_KEYS_NAMES.callsNotAnswerAttemptCount]:
    'Пациенты, не ответившие на звонок',
  [DISPENSARIZATION_STATISTICS_KEYS_NAMES.tasksConfirmedCount]:
    'Пациенты, согласившиеся на диспансеризацию',
  [DISPENSARIZATION_STATISTICS_KEYS_NAMES.tasksDeclinedCount]:
    'Пациенты, отказавшиеся от диспансеризации',
  [DISPENSARIZATION_STATISTICS_KEYS_NAMES.tasksOperatorCount]:
    'Требуется оператор',
  [DISPENSARIZATION_STATISTICS_KEYS_NAMES.firstCallsAttempt]:
    'Заданий, в которых ответили с 1 раза',
  [DISPENSARIZATION_STATISTICS_KEYS_NAMES.secondCallsAttempt]:
    'Заданий, в которых ответили с 2 раза',
  [DISPENSARIZATION_STATISTICS_KEYS_NAMES.thirdCallsAttempt]:
    'Заданий, в которых ответили с 3 раза',
};
